import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { mockTestimonials } from '../data/mockData';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!mockTestimonials || mockTestimonials.length === 0) {
    return null;
  }

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % mockTestimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + mockTestimonials.length) % mockTestimonials.length
    );
  };

  const currentTestimonial = mockTestimonials[currentIndex];

  return (
    <section
      className="bg-zinc-950 py-20 md:py-32 relative overflow-hidden"
      aria-labelledby="testimonials-heading"
    >

      {/* Background Decorative Elements */}
      <div
        className="absolute top-0 left-0 w-96 h-96 bg-red-600/5 rounded-full blur-3xl"
        aria-hidden="true"
      />

      <div
        className="absolute bottom-0 right-0 w-96 h-96 bg-red-600/5 rounded-full blur-3xl"
        aria-hidden="true"
      />

      <div className="container mx-auto px-6 relative z-10">

        {/* Section Header */}
        <div className="text-center mb-16">

          <h2
            id="testimonials-heading"
            className="text-white text-5xl md:text-6xl font-bold mb-6"
          >
            Member Experiences
          </h2>

          <p className="text-gray-400 text-lg">
            Discover what members have to say about their Bond Boxing experience.
          </p>

        </div>

        {/* Testimonial Card */}
        <div className="max-w-4xl mx-auto">

          <article
            className="bg-black border border-gray-800 p-12 md:p-16 relative"
            aria-live="polite"
            aria-atomic="true"
          >

            {/* Quote Icon */}
            <div
              className="text-red-600 text-6xl font-serif mb-6 opacity-50"
              aria-hidden="true"
            >
              “
            </div>

            {/* Testimonial Content */}
            <div className="mb-8">

              <blockquote className="text-white text-xl md:text-2xl leading-relaxed mb-8 italic">
                {currentTestimonial.quote}
              </blockquote>

              <div className="flex items-center gap-4">

                <div
                  className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold"
                  aria-hidden="true"
                >
                  {currentTestimonial.name.charAt(0)}
                </div>

                <div>
                  <div className="text-white font-bold text-lg">
                    {currentTestimonial.name}
                  </div>

                  <div className="text-red-500 text-sm font-semibold tracking-wider">
                    {currentTestimonial.program}
                  </div>
                </div>

              </div>

            </div>

            {/* Navigation Buttons */}
            <div className="flex items-center justify-between mt-8 pt-8 border-t border-gray-800">

              <button
                type="button"
                onClick={prevTestimonial}
                aria-label="Previous testimonial"
                className="text-white hover:text-red-500 transition-colors duration-300 flex items-center gap-2 font-semibold"
              >
                <ChevronLeft size={24} aria-hidden="true" />
                Previous
              </button>

              <div
                className="text-gray-500 font-medium"
                aria-label={`Testimonial ${currentIndex + 1} of ${mockTestimonials.length}`}
              >
                {currentIndex + 1} / {mockTestimonials.length}
              </div>

              <button
                type="button"
                onClick={nextTestimonial}
                aria-label="Next testimonial"
                className="text-white hover:text-red-500 transition-colors duration-300 flex items-center gap-2 font-semibold"
              >
                Next
                <ChevronRight size={24} aria-hidden="true" />
              </button>

            </div>

          </article>

        </div>

      </div>

    </section>
  );
};

export default TestimonialsSection;